import { BrowserUtils } from '../../utils/siteUtils'
import useEventBus from './useEventBus'

//excluding 'ico_photos' because it causes an extra back call to be triggered into the dataLayer
const EXCLUSION_LIST = ['ico_mods', 'adtn_photo-ico_condition_img']
const CONVERT_TO_FURE = {
  'cta::continue_error::ineligible': 'continue_error',
  'video::start': 'video_start',
  'video::25%': 'video_milestones_25%',
  'video::50%': 'video_milestones_50%',
  'video::75%': 'video_milestones_75%',
  'video::complete': 'video_complete'
}

const QUEUE_INTERVAL = 100
let lastEventTimestamp = 0

export default (globalState, updateGlobalState) => {
  if (BrowserUtils.isSSG) return

  useEventBus('TrackingEvent', event => {
    forwardAnalytics(event)
  })

  const forwardAnalytics = event => {
    if (shouldForward(event)) {
      queueEvent(globalState.fireAnalytics, event)
    }
  }

  const shouldForward = event => {
    const { eventResult, eventData } = event
    if (EXCLUSION_LIST.includes(eventResult)) {
      return false
    }

    const { vehicle } = eventData || {}
    const mileageNextError = eventResult === 'cta::mileage::next' && !vehicle.mileage
    const styleNextError = eventResult === 'cta::style::next' && (!vehicle.trimId || !vehicle.mileage)
    const hasErrors = mileageNextError || styleNextError

    return !hasErrors
  }

  const queueEvent = (fireAnalytics, event) => {
    const timeSinceLastEvent = Date.now() - lastEventTimestamp
    if (event.eventResult === 'cta::modal::skip') {
      setTimeout(() => fireEvent(event), 500)
    } else if (fireAnalytics === undefined && timeSinceLastEvent > QUEUE_INTERVAL) {
      fireEvent(event)
      lastEventTimestamp = Date.now()
    } else {
      setTimeout(queueEvent, QUEUE_INTERVAL, fireAnalytics, event)
    }
  }

  const fireEvent = event => {
    const { eventResult, eventElement, eventData } = event
    const convertedEventResult = CONVERT_TO_FURE[eventResult]
    
    const dataLayer = window.ICO.dataLayer
    if ((dataLayer && eventResult?.startsWith('ico_condition')) || eventResult === 'button::nav::exterior') {
      dataLayer.pageInfo.conditionTab = eventData.previousTab
    }

    updateGlobalState({ fireAnalytics: convertedEventResult || eventResult, componentFunnelAnalytics: true, category: eventElement })

    if (dataLayer && eventData.icoResponses) {
      dataLayer.icoResponses = eventData.icoResponses
    }

  }
}